export default __webpack_public_path__ + "assets/fonts/ada6e6df937f7e5e8b790dfea07109b7.woff2";